import { Facebook, Twitter, Linkedin, Send } from "lucide-react";
import { Button } from "@/components/ui/button";

const SocialShare = ({ url, title }) => {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const shareLinks = [
    {
      name: "Facebook",
      icon: Facebook,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      color: "hover:bg-[#1877F2] hover:text-white",
    },
    {
      name: "Twitter",
      icon: Twitter,
      url: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
      color: "hover:bg-[#1DA1F2] hover:text-white",
    },
    {
      name: "LinkedIn",
      icon: Linkedin,
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      color: "hover:bg-[#0A66C2] hover:text-white",
    },
    {
      name: "WhatsApp",
      icon: Send,
      url: `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`,
      color: "hover:bg-[#25D366] hover:text-white",
    },
  ];

  const handleShare = (shareUrl) => {
    window.open(shareUrl, "_blank", "width=600,height=400");
  };

  return (
    <div className="flex items-center gap-2" data-testid="social-share">
      <span className="text-sm text-muted-foreground mr-2">Partager:</span>
      {shareLinks.map((social) => (
        <Button
          key={social.name}
          variant="ghost"
          size="icon"
          onClick={() => handleShare(social.url)}
          data-testid={`share-${social.name.toLowerCase()}`}
          className={`rounded-full transition-all ${social.color}`}
        >
          <social.icon className="h-4 w-4" />
        </Button>
      ))}
    </div>
  );
};

export default SocialShare;
